import { render, staticRenderFns } from "./article_id.vue?vue&type=template&id=efa9f1e0&"
import script from "./article_id.vue?vue&type=script&lang=js&"
export * from "./article_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports